import styles from './tooltip-number.module.scss';
import TooltipDecimal from 'components/tooltip-decimal/tooltip-decimal';

export const formatNumberWithTooltip = (
  value: any,
  precision: number = 8,
  defaultText: string = '0.00000000',
  isPercentage: boolean = false,
  unit?: string
): React.ReactNode | string => {
  if (value === null || value === undefined) {
    return defaultText;
  }

  const numValue = typeof value === 'string' ? parseFloat(value) : value;

  if (typeof numValue !== 'number' || isNaN(numValue)) {
    return defaultText;
  }

  return (
    <span className={styles.numericCell}>
      <TooltipDecimal
        value={numValue}
        precision={precision}
        isPercentage={isPercentage}
      />
      {unit && <span> {unit}</span>}
    </span>
  );
};
